import { Location } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-restricted-access',
  templateUrl: './restricted-access.component.html',
  styleUrls: ['./restricted-access.component.scss']
})
export class RestrictedAccessComponent {

  constructor(private location: Location) {

  }

  navigateBack() {
    this.location.back();
  }

}
